import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { PureComponent, Fragment } from 'react';
import styled from 'styled-components';
import BBCode from './shared/richText/BBCode';
import ButtonShowMoreLess from './shared/buttons/ButtonShowMoreLess';
var RichTextBlockExpand = /*#__PURE__*/function (_PureComponent) {
  function RichTextBlockExpand() {
    var _this;
    _classCallCheck(this, RichTextBlockExpand);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, RichTextBlockExpand, [].concat(args));
    _defineProperty(_this, "state", {
      expanded: false
    });
    _defineProperty(_this, "toggleExpand", function () {
      _this.setState({
        expanded: !_this.state.expanded
      });
    });
    return _this;
  }
  _inherits(RichTextBlockExpand, _PureComponent);
  return _createClass(RichTextBlockExpand, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var expanded = this.state.expanded;
      var richtext = this.props.richtext;
      return __jsx(Fragment, null, __jsx(Container, {
        expanded: expanded,
        maxHeight: this.textContent && this.textContent.offsetHeight,
        "data-id": "components_RichTextBlockExpand_Container"
      }, __jsx("div", {
        ref: function ref(input) {
          _this2.textContent = input;
        },
        "data-id": "components_RichTextBlockExpand_div"
      }, __jsx(BBCode, {
        content: richtext,
        "data-id": "components_RichTextBlockExpand_BBCode"
      })), !expanded && __jsx(Fade, {
        showMore: expanded,
        "data-id": "components_RichTextBlockExpand_Fade"
      })), __jsx(ButtonContainer, {
        showMore: expanded,
        "data-id": "components_RichTextBlockExpand_ButtonContainer"
      }, __jsx(ButtonShowMoreLess, {
        label: expanded ? 'Toon minder' : 'Toon meer',
        direction: expanded ? 'up' : 'down',
        clickHandler: this.toggleExpand,
        "data-id": "components_RichTextBlockExpand_ButtonShowMoreLess"
      })));
    }
  }]);
}(PureComponent);
export default RichTextBlockExpand;
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: 100%;\n  max-height: ", "rem;\n  overflow: hidden;\n  transition: max-height 0.4s ease-in-out;\n"])), function (props) {
  return props.expanded ? props.maxHeight : '300';
});
var ButtonContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  height: 120rem;\n"])));
var Fade = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  position: absolute;\n  bottom: 0;\n  height: 60rem;\n  width: 100%;\n  background: linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 1));\n"])));